"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _IconConstants = require("../icon/IconConstants");

var _UICaret = _interopRequireDefault(require("../icon/icons/UICaret"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _Styles = require("../utils/Styles");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  position: relative;\n  line-height: ", ";\n  ", ";\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n\n    ", " {\n      color: currentColor;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-left: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  stroke: ", ";\n  position: absolute;\n  left: 0;\n  ", ";\n  transform: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var indicatorCanvasStyle = {
  display: 'block',
  width: '100%',
  visibility: 'hidden'
};
var indicatorCaretStyle = {
  position: 'absolute',
  width: '100%',
  left: 0,
  top: 0
};
var indicatorCoordinatesForSize = {
  xs: 'top: 7px; width: 5px;',
  sm: 'top: 3px; width: 7px;',
  md: 'top: 4px; width: 8px;',
  lg: 'top: 3px; width: 11px;',
  xl: 'top: 10px; width: 11px;'
};

var Indicator = _styledComponents.default.div.withConfig({
  displayName: "UIAccordionItem__Indicator",
  componentId: "sc-91c820-0"
})(_templateObject(), _theme.BASE_LINK_COLOR, function (_ref) {
  var size = _ref.size;
  return indicatorCoordinatesForSize[size];
}, function (_ref2) {
  var open = _ref2.open;
  return open && 'rotate(90deg)';
}, (0, _Styles.setUiTransition)());

var ExtraSmallHeading = _styledComponents.default.div.withConfig({
  displayName: "UIAccordionItem__ExtraSmallHeading",
  componentId: "sc-91c820-1"
})(_templateObject2());

var headingForSize = {
  xs: ExtraSmallHeading,
  sm: 'h5',
  md: 'h4',
  lg: 'h2',
  xl: 'h1'
};
var paddingLeftForSize = {
  xs: 17,
  sm: 23,
  md: 27,
  lg: 30,
  xl: 30
};
var paddingLeftMixin = (0, _styledComponents.css)(_templateObject3(), function (_ref3) {
  var size = _ref3.size;
  return paddingLeftForSize[size];
});
var Clickable = (0, _styledComponents.default)(function (_ref4) {
  var __open = _ref4.open,
      __size = _ref4.size,
      rest = (0, _objectWithoutProperties2.default)(_ref4, ["open", "size"]);
  return _react.default.createElement(_UIClickable.default, rest);
}).withConfig({
  displayName: "UIAccordionItem__Clickable",
  componentId: "sc-91c820-2"
})(_templateObject4(), _sizes.BASE_LINE_HEIGHT, paddingLeftMixin, _theme.BASE_LINK_HOVER_COLOR, Indicator);
var Transition = (0, _styledComponents.default)(function (_ref5) {
  var __size = _ref5.size,
      rest = (0, _objectWithoutProperties2.default)(_ref5, ["size"]);
  return _react.default.createElement(_AccordionTransition.default, rest);
}).withConfig({
  displayName: "UIAccordionItem__Transition",
  componentId: "sc-91c820-3"
})(_templateObject5(), paddingLeftMixin);
var UIAccordionItem = (0, _memoWithDisplayName.default)('UIAccordionItem', function (props) {
  var animate = props.animate,
      children = props.children,
      Content = props.Content,
      renderContent = props.renderContent,
      contentClassName = props.contentClassName,
      disabled = props.disabled,
      flush = props.flush,
      onOpenChange = props.onOpenChange,
      open = props.open,
      size = props.size,
      title = props.title,
      titleClassName = props.titleClassName,
      rest = (0, _objectWithoutProperties2.default)(props, ["animate", "children", "Content", "renderContent", "contentClassName", "disabled", "flush", "onOpenChange", "open", "size", "title", "titleClassName"]);
  var handleTitleClick = (0, _react.useCallback)(function () {
    onOpenChange((0, _SyntheticEvent.default)(!open));
  }, [onOpenChange, open]);
  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  var computedTitleClassName = (0, _classnames.default)(titleClassName, 'private-accordion');
  var Heading = headingForSize[shorthandSize];
  return _react.default.createElement("div", rest, _react.default.createElement(Clickable, {
    "aria-expanded": open,
    className: computedTitleClassName,
    disabled: disabled,
    onClick: handleTitleClick,
    open: open,
    size: shorthandSize
  }, _react.default.createElement(Heading, {
    role: "presentation",
    className: flush ? 'm-bottom-0' : ''
  }, _react.default.createElement(Indicator, {
    open: open,
    size: shorthandSize
  }, _react.default.createElement("canvas", {
    width: _IconConstants.CARET_WIDTH,
    height: _IconConstants.CARET_HEIGHT,
    style: indicatorCanvasStyle
  }), _react.default.createElement(_UICaret.default, {
    style: indicatorCaretStyle,
    viewBoxHeight: _IconConstants.CARET_HEIGHT,
    viewBoxWidth: _IconConstants.CARET_WIDTH,
    width: 12
  })), title)), _react.default.createElement(Transition, {
    Content: Content,
    renderContent: renderContent,
    duration: animate ? undefined : 0,
    className: (0, _classnames.default)('UIAccordionItem-content', 'private-accordion__content', contentClassName),
    open: open,
    size: shorthandSize
  }, children));
});
UIAccordionItem.propTypes = {
  animate: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node,
  Content: _propTypes.default.elementType,
  renderContent: _propTypes.default.func,
  contentClassName: _propTypes.default.string,
  disabled: _propTypes.default.bool.isRequired,
  flush: _propTypes.default.bool.isRequired,
  onOpenChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  title: _propTypes.default.node.isRequired,
  titleClassName: _propTypes.default.string,
  size: _tshirtSize.allSizes
};
UIAccordionItem.defaultProps = {
  animate: true,
  disabled: false,
  flush: false,
  open: false,
  size: 'xs'
};

var _default = (0, _Controllable.default)(UIAccordionItem, ['open']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/accordion/UIAccordionItem.js
// module id = 361
// module chunks = 209 210 211 212